(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["weluxe-certificat"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.wlCertif) return;
    window.wlCertif = true;
    document.addEventListener('click', function (ev) {
      var bouton = ev.target && ev.target.closest ? ev.target.closest('.wl-certif__bouton') : null;
      if (!bouton) return;
      var carte = bouton.closest('.wl-certif');
      if (!carte) return;
      var oui = carte.classList.toggle('est-retourne');
      bouton.setAttribute('aria-pressed', oui ? 'true' : 'false');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
